import Box from '@eversports/klimt-primitives/legacy/Box'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../localization/react'

interface Props {
  handleClick: () => void
}

const ShowMore = ({ handleClick }: Props) => {
  // ACCESSIBILITY TODO - Update <Box /> definition, use the prop component="button"
  return (
    <Box component="button" onClick={handleClick} sx={{ width: '100%', cursor: 'pointer' }}>
      <Text variant="label" color="midnight" sx={{ textAlign: 'center' }}>
        <Localized id="activity-detail-reviews-show-more" />
      </Text>
    </Box>
  )
}

export default ShowMore
